import { updateTextComponentBackgroundColor } from './update-text-component-background-color';
import { updateTextComponentTextColor } from './update-text-component-text-color';
export const updateTextComponentStyle = (component, textColor, backgroundColor) => {
  const {
    data
  } = component;
  let updatedTextComponent = updateTextComponentTextColor(data.text, textColor);
  if (backgroundColor) {
    updatedTextComponent = updateTextComponentBackgroundColor(updatedTextComponent, backgroundColor);
  }
  return updatedTextComponent;
};
export const updateTextComponentBackgroundStyle = (component, backgroundColor) => {
  const {
    data
  } = component;
  return updateTextComponentBackgroundColor(data.text, backgroundColor);
};
//# sourceMappingURL=update-text-component-style.js.map